/* eslint-disable */
const olx = `<problem>
  <optionresponse>
    <optioninput>
      <option correct="True"></option>
      <option correct="False"></option>
      <option correct="False"></option>
    </optioninput>
  </optionresponse>
</problem>`

const markdown = `[[
an incorrect answer
(the correct answer)
an incorrect answer
]]`

export default { olx, markdown };
